var map = {
	"./": "fdMs",
	"./address": "IM8/",
	"./address/": "IM8/",
	"./address/index": "IM8/",
	"./address/index.js": "IM8/",
	"./common": "va7N",
	"./common/": "va7N",
	"./common/index": "va7N",
	"./common/index.js": "va7N",
	"./index": "fdMs",
	"./index.js": "fdMs",
	"./injections": "5ewm",
	"./injections/": "5ewm",
	"./injections/index": "5ewm",
	"./injections/index.js": "5ewm",
	"./orderFulfillment": "w90A",
	"./orderFulfillment/": "w90A",
	"./orderFulfillment/index": "w90A",
	"./orderFulfillment/index.js": "w90A",
	"./store_customer_private_data": "lckp",
	"./store_customer_private_data/": "lckp",
	"./store_customer_private_data/index": "lckp",
	"./store_customer_private_data/index.js": "lckp"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "tuez";